import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { MaliciousCallMailConfigRemoteDto } from 'src/generated/signalR/malicious-call-mail-config-remote-dto';
import { MaliciousCallMailConfigChanged } from './samwin-malicious-call-mail-config.action';

export interface SamwinMaliciousCallMailConfigStateModel {
   mailconfig: MaliciousCallMailConfigRemoteDto;
}

@State<SamwinMaliciousCallMailConfigStateModel>({
   name: 'samwinMaliciousCallMailConfig',
   defaults: {
      mailconfig: null,
   },
})
@Injectable()
export class SamwinMaliciousCallMailConfigState {
   constructor() {}

   @Selector([SamwinMaliciousCallMailConfigState])
   public static getMaliciousCallMailConfig(state: SamwinMaliciousCallMailConfigStateModel): MaliciousCallMailConfigRemoteDto {
      return state.mailconfig;
   }

   @Action(MaliciousCallMailConfigChanged)
   public maliciousCallMailConfigChanged(ctx: StateContext<SamwinMaliciousCallMailConfigStateModel>, action: MaliciousCallMailConfigChanged) {
      ctx.patchState({
         mailconfig: action.mailconfig,
      });
   }
}
